import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';


interface CreditPackage {
  id: string;
  credits: number;
  price: number;
  pricePerCredit: string;
}

@Component({
    selector: 'app-buy-credits',
    imports: [MatButtonModule, MatCardModule, MatDialogModule, MatIconModule, TranslateModule],
    templateUrl: './buy-credits.component.html',
    styleUrl: './buy-credits.component.scss'
})
export class BuyCreditsComponent {
  private dialogRef = inject(MatDialogRef<BuyCreditsComponent>);

  credits: number = 0;

  // Elenco opzioni di acquisto crediti
  creditPackages: CreditPackage[] = [
    { id: 'crediti-1', credits: 1000, price: 7.80, pricePerCredit: '' },
    { id: 'crediti-2', credits: 2000, price: 14.90, pricePerCredit: '' },
    // { id: 'crediti-3', credits: 1000, price: 19.99, pricePerCredit: 0 }
  ];

  selectedPackage: CreditPackage | null = null;

  constructor() {
    for (let i = 0; i < this.creditPackages.length; i++) {
      this.creditPackages[i].pricePerCredit = (this.creditPackages[i].price / this.creditPackages[i].credits).toFixed(4);
    }
  }

  selectPackage(pkg: CreditPackage) {
    this.selectedPackage = pkg;
  }

  addToCart() {
    if (this.selectedPackage) {
      this.dialogRef.close(this.selectedPackage);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
